export enum OperatorEnum {
  MCI = 1,
  MTN = 2,
  RighTel = 3,
  Talya = 4
}
